import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=e379a774&scoped=true&"
import script from "./Impressum.vue?vue&type=script&lang=js&"
export * from "./Impressum.vue?vue&type=script&lang=js&"
import style0 from "./Impressum.vue?vue&type=style&index=0&id=e379a774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e379a774",
  null
  
)

export default component.exports